{
  "table": {
    "empty": "The table is empty",
    "notVisibleColumns": "You have hidden all the columns in the table"
  }
}
